import { del, get, set } from "idb-keyval";
import { getOrCreateStorageSessionId } from "@/src/util/storage-session";
import { createSessionScopedStorage } from "@/src/util/session-scoped-storage";

if (typeof sessionStorage !== "undefined") {
  getOrCreateStorageSessionId();
}

const isBrowser = typeof indexedDB !== "undefined";

const baseIndexedDBStorage = isBrowser
  ? {
      getItem: async (key: string): Promise<string | null> => {
        const value = await get(key);
        return value !== undefined ? JSON.stringify(value) : null;
      },
      setItem: async (key: string, value: string): Promise<void> => {
        await set(key, JSON.parse(value));
      },
      removeItem: async (key: string): Promise<void> => {
        await del(key);
      },
    }
  : {
      getItem: async () => null,
      setItem: async () => {},
      removeItem: async () => {},
    };

const indexedDBStorage = createSessionScopedStorage(baseIndexedDBStorage);

export default indexedDBStorage;
